import { render, staticRenderFns } from "./SpeedStats.vue?vue&type=template&id=b54aa84a&scoped=true&"
import script from "./SpeedStats.vue?vue&type=script&lang=js&"
export * from "./SpeedStats.vue?vue&type=script&lang=js&"
import style0 from "./SpeedStats.vue?vue&type=style&index=0&id=b54aa84a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b54aa84a",
  null
  
)

export default component.exports